var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36 0 C 55.882812 0 72 16.117188 72 36 C 72 55.882812 55.882812 72 36 72 C 16.117188 72 0 55.882812 0 36 C 0 16.117188 16.117188 0 36 0 Z M 36 0 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 17 L 46 17 L 46 37 L 26 37 Z M 26 17 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36 0 C 55.882812 0 72 16.117188 72 36 C 72 55.882812 55.882812 72 36 72 C 16.117188 72 0 55.882812 0 36 C 0 16.117188 16.117188 0 36 0 Z M 36 0 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20 39 L 52 39 L 52 55 L 20 55 Z M 20 39 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36 0 C 55.882812 0 72 16.117188 72 36 C 72 55.882812 55.882812 72 36 72 C 16.117188 72 0 55.882812 0 36 C 0 16.117188 16.117188 0 36 0 Z M 36 0 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.117647%,94.117647%,94.117647%)",
      fillOpacity: 1
    },
    d: "M 96 36 C 96 69.136719 69.136719 96 36 96 C 2.863281 96 -24 69.136719 -24 36 C -24 2.863281 2.863281 -24 36 -24 C 69.136719 -24 96 2.863281 96 36 Z M 96 36 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(8.235294%,21.960784%,61.176471%)",
      fillOpacity: 1
    },
    d: "M 36 17.796875 C 30.707031 17.796875 26.398438 22.101562 26.398438 27.394531 C 26.398438 32.6875 30.707031 36.996094 36 36.996094 C 41.292969 36.996094 45.601562 32.6875 45.601562 27.394531 C 45.601562 22.101562 41.292969 17.796875 36 17.796875 Z M 36 17.796875 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(8.235294%,21.960784%,61.176471%)",
      fillOpacity: 1
    },
    d: "M 47.945312 43.265625 C 45.316406 40.597656 41.832031 39.128906 38.132812 39.128906 L 33.867188 39.128906 C 30.167969 39.128906 26.683594 40.597656 24.054688 43.265625 C 21.441406 45.921875 20 49.429688 20 53.136719 C 20 53.726562 20.476562 54.203125 21.066406 54.203125 L 50.933594 54.203125 C 51.523438 54.203125 52 53.726562 52 53.136719 C 52 49.429688 50.558594 45.921875 47.945312 43.265625 Z M 47.945312 43.265625 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAvatar);
export default __webpack_public_path__ + "static/media/profileAvatar.81f5800568898c0b9456d0368407a17c.svg";
export { ForwardRef as ReactComponent };